import React, { Component } from "react";
import StartImg from "../../assets/images/login_start.png";
import * as Business from "../../utils/business";

export default class WelcomeScreen extends Component {
  render() {
    return (
      <div
        style={{
          height: "calc(100vh - 20px - 75px - 20px)",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          gap: 16,
          width: "calc(100% - 40px)",
          margin: "0 20px",
          backgroundColor: "#FFFFFF",
          borderRadius: 12,
          border: "1px solid #E3E3E3",
        }}
      >
        <img src={StartImg} alt="Welcome illustration" style={{ width: 300 }} />
        <h2
          style={{
            fontSize: 24,
            fontWeight: 600,
            color: "#404040",
            margin: 0,
            lineHeight: 1.2,
          }}
        >
          {`Welcome back, ${Business.getAccountFullName()}`}
        </h2>
        <p
          style={{
            color: "#8D8D8D",
            fontSize: 20,
            fontWeight: 400,
            margin: 0,
            lineHeight: 1.2,
          }}
        >
          {Business.convertToFullDate(new Date())}
        </p>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/Dashboard/Dashboard.js